/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetEvidenceRecords200ResponseInnerErrors
 */
export interface GetEvidenceRecords200ResponseInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerErrors
     */
    'detectedDpi'?: GetEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerErrors
     */
    'calculatedDpi'?: GetEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerErrors
     */
    'colorGradation'?: GetEvidenceRecords200ResponseInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerErrors
     */
    'heightMillis'?: GetEvidenceRecords200ResponseInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerErrors
     */
    'widthMillis'?: GetEvidenceRecords200ResponseInnerErrorsWidthMillisEnum;
}

export const GetEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum = typeof GetEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum[keyof typeof GetEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum];
export const GetEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum = typeof GetEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum[keyof typeof GetEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum];
export const GetEvidenceRecords200ResponseInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetEvidenceRecords200ResponseInnerErrorsColorGradationEnum = typeof GetEvidenceRecords200ResponseInnerErrorsColorGradationEnum[keyof typeof GetEvidenceRecords200ResponseInnerErrorsColorGradationEnum];
export const GetEvidenceRecords200ResponseInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidenceRecords200ResponseInnerErrorsHeightMillisEnum = typeof GetEvidenceRecords200ResponseInnerErrorsHeightMillisEnum[keyof typeof GetEvidenceRecords200ResponseInnerErrorsHeightMillisEnum];
export const GetEvidenceRecords200ResponseInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidenceRecords200ResponseInnerErrorsWidthMillisEnum = typeof GetEvidenceRecords200ResponseInnerErrorsWidthMillisEnum[keyof typeof GetEvidenceRecords200ResponseInnerErrorsWidthMillisEnum];


